/**
 * Configuração central das URLs da API
 * 
 * Ao usar URLs diretas das Cloud Functions, garantimos que a aplicação
 * não dependa do Firebase Auth e Functions Emulator
 */

const API_URLS = {
  // URLs do Firebase Hosting
  login: 'https://kmfengenharia.web.app/api/login',
  signup: 'https://kmfengenharia.web.app/api/signup',
  api: 'https://kmfengenharia.web.app/api/',
  
  // URLs diretas das Cloud Functions (alternativas)
  login_direct: 'https://login-jtoioxpfwq-uc.a.run.app',
  signup_direct: 'https://signup-jtoioxpfwq-uc.a.run.app',
  api_direct: 'https://api-jtoioxpfwq-uc.a.run.app/',
  testDbConnection: 'https://testdbconnection-jtoioxpfwq-uc.a.run.app',
  
  // URLs alternativas para contornar problemas de CORS
  login_alt: 'https://us-central1-kmfengenharia.cloudfunctions.net/login',
  signup_alt: 'https://us-central1-kmfengenharia.cloudfunctions.net/signup',
  orcamentos_alt: 'https://us-central1-kmfengenharia.cloudfunctions.net/orcamentos',
  orcamento_alt: 'https://us-central1-kmfengenharia.cloudfunctions.net/orcamento',
  
  // URLs para controle de custos
  custos: 'https://custos-jtoioxpfwq-uc.a.run.app',
  custos_direct: 'https://custos-jtoioxpfwq-uc.a.run.app',
  custos_alt: 'https://us-central1-kmfengenharia.cloudfunctions.net/custos',
  
  // Endpoints específicos para acesso direto
  orcamentos: 'https://kmfengenharia.web.app/api/orcamentos',
  orcamento: 'https://kmfengenharia.web.app/api/orcamento',
  projeto: 'https://orcamento-jtoioxpfwq-uc.a.run.app/projeto',
  projeto_save_all: 'https://orcamento-jtoioxpfwq-uc.a.run.app/projeto-save-all',
  projeto_itens: 'https://orcamento-jtoioxpfwq-uc.a.run.app/projeto-itens',
  projeto_item: 'https://orcamento-jtoioxpfwq-uc.a.run.app/projeto-item',
  projeto_secao: 'https://orcamento-jtoioxpfwq-uc.a.run.app/projeto-secao',
  configuracao: 'https://orcamento-jtoioxpfwq-uc.a.run.app/configuracao',
  configuracao_direct: 'https://configuracao-jtoioxpfwq-uc.a.run.app',

  
  // URLs diretas alternativas (fallback)
  orcamentos_direct: 'https://orcamento-jtoioxpfwq-uc.a.run.app/orcamentos',
  orcamento_direct: 'https://orcamento-jtoioxpfwq-uc.a.run.app/orcamento',
  
  // URLs para orçamentos com múltiplos fallbacks
  getOrcamentosUrls: () => [
    'https://kmfengenharia.web.app/api/orcamentos',
    'https://orcamento-jtoioxpfwq-uc.a.run.app/orcamentos',
    'https://us-central1-kmfengenharia.cloudfunctions.net/orcamentos'
  ],
  
  // Funções para API de custos
  getCustosUrl: () => 'https://custos-jtoioxpfwq-uc.a.run.app',
  getCustosAltUrl: () => 'https://us-central1-kmfengenharia.cloudfunctions.net/custos',
  getCustoDetalheUrl: (transacaoId) => `https://custos-jtoioxpfwq-uc.a.run.app/${transacaoId}`,
  getCustosFiltradosUrl: (filtros) => {
    const queryParams = new URLSearchParams(filtros).toString();
    return `https://custos-jtoioxpfwq-uc.a.run.app?${queryParams}`;
  },
  
  // Funções auxiliares para construir URLs completas
  getProjetoItemsUrl: (projetoId) => `https://orcamento-jtoioxpfwq-uc.a.run.app/projeto-itens/${projetoId}`,
  getOrcamentoUrl: (id) => `https://kmfengenharia.web.app/api/orcamento/${id}`,
  getOrcamentoDirectUrl: (id) => `https://orcamento-jtoioxpfwq-uc.a.run.app/orcamento/${id}`,
  getOrcamentoAltUrl: (id) => `https://us-central1-kmfengenharia.cloudfunctions.net/orcamento/${id}`,
  getProjetoUrl: (id) => `https://orcamento-jtoioxpfwq-uc.a.run.app/projeto/${id}`,
  getSaveAllUrl: (id) => `https://orcamento-jtoioxpfwq-uc.a.run.app/projeto-save-all/${id}`,
  getProjetoSecaoUrl: (projetoId) => `https://orcamento-jtoioxpfwq-uc.a.run.app/projeto-secao/${projetoId}`,
  getProjetoItemUrl: (projetoId) => `https://orcamento-jtoioxpfwq-uc.a.run.app/projeto-item/${projetoId}`,
  getConfiguracaoUrl: () => `https://configuracao-jtoioxpfwq-uc.a.run.app`,
  getDiarioObraConfiguracaoUrl: () => `https://diarioobras-jtoioxpfwq-uc.a.run.app/configuracao`,

  
  // URLs para operações de atualização e exclusão
  updateProjetoItemUrl: (projetoId, itemId) => `https://orcamento-jtoioxpfwq-uc.a.run.app/projeto-item/${projetoId}/${itemId}`,
  deleteProjetoItemUrl: (projetoId, itemId) => `https://orcamento-jtoioxpfwq-uc.a.run.app/projeto-item/${projetoId}/${itemId}`,
  deleteProjetoSecaoUrl: (projetoId, secaoId) => `https://orcamento-jtoioxpfwq-uc.a.run.app/projeto-secao/${projetoId}/${secaoId}`,
  
  // URLs para operações de CRUD em custos
  createCustoUrl: () => 'https://custos-jtoioxpfwq-uc.a.run.app',
  updateCustoUrl: (transacaoId) => `https://custos-jtoioxpfwq-uc.a.run.app/${transacaoId}`,
  deleteCustoUrl: (transacaoId) => `https://custos-jtoioxpfwq-uc.a.run.app/${transacaoId}`,
  getResumoFinanceiroUrl: (filtros) => {
    const queryParams = new URLSearchParams(filtros).toString();
    return `https://custos-jtoioxpfwq-uc.a.run.app/resumo?${queryParams}`;
  },
  
  // URLs para atualização de diário de obras
  updateDiarioObraUrl: (obraId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}`,
  deleteDiarioObraUrl: (obraId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}`,
  
  // URLs para diário de obras
  diarioObras: 'https://diarioobras-jtoioxpfwq-uc.a.run.app',
  diarioObras_direct: 'https://diarioobras-jtoioxpfwq-uc.a.run.app',
  
  // URLs para aprovação de RDO
  aprovarRDO: 'https://aprovarrdo-jtoioxpfwq-uc.a.run.app',
  aprovarRDO_alt: 'https://us-central1-kmfengenharia.cloudfunctions.net/aprovarRDO',
  
  // Funções auxiliares para construir URLs de aprovação de RDO
  getAprovarRDODetalheUrl: (obraId, data) => `https://aprovarrdo-jtoioxpfwq-uc.a.run.app/aprovar/${obraId}?data=${data}`,
  getAprovacaoRDODetalheUrl: (obraId, data) => `https://us-central1-kmfengenharia.cloudfunctions.net/aprovarRDO/aprovar/${obraId}?data=${data}`,
  getAprovarRDOStatusUrl: (obraId, data) => `https://aprovarrdo-jtoioxpfwq-uc.a.run.app/status/${obraId}?data=${data}`,
  getAprovacaoRDOStatusUrl: (obraId, data) => `https://us-central1-kmfengenharia.cloudfunctions.net/aprovarRDO/status/${obraId}?data=${data}`,
  getAprovarRDOListaUrl: (obraId) => `https://aprovarrdo-jtoioxpfwq-uc.a.run.app/listar/${obraId}`,
  getAprovacaoRDOListaUrl: (obraId) => `https://us-central1-kmfengenharia.cloudfunctions.net/aprovarRDO/listar/${obraId}`,
  
  // URLs para clientes
  clientes: 'https://clientes-jtoioxpfwq-uc.a.run.app',
  clientes_direct: 'https://clientes-jtoioxpfwq-uc.a.run.app',
  clientes_alt: 'https://us-central1-kmfengenharia.cloudfunctions.net/clientes',
  
  // Funções auxiliares para construir URLs completas para clientes
  getClientesUrl: () => 'https://clientes-jtoioxpfwq-uc.a.run.app',
  getClienteUrl: (clienteId) => `https://clientes-jtoioxpfwq-uc.a.run.app/${clienteId}`,
  updateClienteUrl: (clienteId) => `https://clientes-jtoioxpfwq-uc.a.run.app/${clienteId}`,
  deleteClienteUrl: (clienteId) => `https://clientes-jtoioxpfwq-uc.a.run.app/${clienteId}`,
  
  // Funções auxiliares para construir URLs para diário de obras
  getDiarioObrasUrl: () => 'https://diarioobras-jtoioxpfwq-uc.a.run.app',
  getDiarioObraDetalhesUrl: (obraId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}`,
  getDiarioObraRegistroUrl: (obraId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}/registro`,
  getDiarioObraRegistroDetalheUrl: (obraId, registroId) => 
    `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}/registro/${registroId}`,
  
  // URLs para upload e gerenciamento de fotos e outros tipos de mídia
  getDiarioObraFotosUrl: (obraId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}/fotos`,
  getDiarioObraFotoDetalheUrl: (obraId, fotoId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}/fotos/${fotoId}`,
  getDiarioObraFotoArquivoUrl: (obraId, fotoId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}/fotos/${fotoId}/arquivo`,
  
  // URLs para outros tipos de registros de mídia
  getDiarioObraEquipamentosUrl: (obraId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}/equipamentos`,
  getDiarioObraAtividadesUrl: (obraId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}/atividade`,
  getDiarioObraMaoDeObraUrl: (obraId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}/maoDeObra`,
  getDiarioObraClimaUrl: (obraId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}/clima`,
  getDiarioObraMateriaisUrl: (obraId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}/materiais`,
  getDiarioObraGeraisUrl: (obraId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}/gerais`,
  getDiarioObraAprovacaoUrl: (obraId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}/aprovacao`,
  // Função genérica para qualquer tipo de mídia
  getDiarioObraMediaUrl: (obraId, tipoMedia) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}/${tipoMedia}`,
  getDiarioObraMediaItemUrl: (obraId, tipoMedia, itemId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}/${tipoMedia}/${itemId}`,
  getDiarioObraMediaArquivoUrl: (obraId, tipoMedia, itemId) => `https://diarioobras-jtoioxpfwq-uc.a.run.app/${obraId}/${tipoMedia}/${itemId}/arquivo`,
  
  // Função para obter a URL base da API
  getBaseUrl: () => 'https://api-jtoioxpfwq-uc.a.run.app',

  // URLs para alteração de senha
  alterarSenha: 'https://alterarsenha-jtoioxpfwq-uc.a.run.app',
  alterarSenha_direct: 'https://alterarsenha-jtoioxpfwq-uc.a.run.app',
  alterarSenha_alt: 'https://us-central1-kmfengenharia.cloudfunctions.net/alterarSenha',

  // URLs para compartilhamento de obras
  compartilharObra: 'https://compartilharobra-jtoioxpfwq-uc.a.run.app',
  aceitarCompartilhamento: 'https://aceitarcompartilhamento-jtoioxpfwq-uc.a.run.app',
  rejeitarCompartilhamento: 'https://rejeitarcompartilhamento-jtoioxpfwq-uc.a.run.app',
  listarObrasCompartilhadas: 'https://listarobrascompartilhadas-jtoioxpfwq-uc.a.run.app',
  listarObrasPendentes: 'https://listarobraspendentes-jtoioxpfwq-uc.a.run.app',
  
  // Funções auxiliares para compartilhamento de obras
  getCompartilharObraUrl: () => 'https://compartilharobra-jtoioxpfwq-uc.a.run.app',
  getAceitarCompartilhamentoUrl: () => 'https://aceitarcompartilhamento-jtoioxpfwq-uc.a.run.app',
  getRejeitarCompartilhamentoUrl: () => 'https://rejeitarcompartilhamento-jtoioxpfwq-uc.a.run.app',
  getListarObrasCompartilhadasUrl: () => 'https://listarobrascompartilhadas-jtoioxpfwq-uc.a.run.app',
  getListarObrasPendentesUrl: () => 'https://listarobraspendentes-jtoioxpfwq-uc.a.run.app',

  // URLs para recuperação de senha
  solicitarRecuperacaoSenha: 'https://solicitarrecuperacaosenha-jtoioxpfwq-uc.a.run.app',
  redefinirSenha: 'https://redefinirsenha-jtoioxpfwq-uc.a.run.app',
  solicitarRecuperacaoSenha_direct: 'https://solicitarrecuperacaosenha-jtoioxpfwq-uc.a.run.app',
  redefinirSenha_direct: 'https://redefinirsenha-jtoioxpfwq-uc.a.run.app',
  solicitarRecuperacaoSenha_alt: 'https://us-central1-kmfengenharia.cloudfunctions.net/solicitarRecuperacaoSenha',
  redefinirSenha_alt: 'https://us-central1-kmfengenharia.cloudfunctions.net/redefinirSenha',

  // Funções auxiliares para recuperação de senha
  getSolicitarRecuperacaoSenhaUrl: () => 'https://solicitarrecuperacaosenha-jtoioxpfwq-uc.a.run.app',
  getRedefinirSenhaUrl: () => 'https://redefinirsenha-jtoioxpfwq-uc.a.run.app',
  getSolicitarRecuperacaoSenhaAltUrl: () => 'https://us-central1-kmfengenharia.cloudfunctions.net/solicitarRecuperacaoSenha',
  getRedefinirSenhaAltUrl: () => 'https://us-central1-kmfengenharia.cloudfunctions.net/redefinirSenha',

  // URLs para verificação de email
  solicitarVerificacaoEmail: 'https://solicitarverificacaoemail-jtoioxpfwq-uc.a.run.app',
  verificarEmail: 'https://verificaremail-jtoioxpfwq-uc.a.run.app',
  solicitarVerificacaoEmail_direct: 'https://solicitarverificacaoemail-jtoioxpfwq-uc.a.run.app',
  verificarEmail_direct: 'https://verificaremail-jtoioxpfwq-uc.a.run.app',
  solicitarVerificacaoEmail_alt: 'https://us-central1-kmfengenharia.cloudfunctions.net/solicitarVerificacaoEmail',
  verificarEmail_alt: 'https://us-central1-kmfengenharia.cloudfunctions.net/verificarEmail',

  // URLs para controle de diárias de pedreiros
  pedreiros: 'https://pedreiros-jtoioxpfwq-uc.a.run.app',
  pedreiros_direct: 'https://pedreiros-jtoioxpfwq-uc.a.run.app',
  pedreiros_alt: 'https://us-central1-kmfengenharia.cloudfunctions.net/pedreiros',
  
  diarias: 'https://diarias-jtoioxpfwq-uc.a.run.app',
  diarias_direct: 'https://diarias-jtoioxpfwq-uc.a.run.app',
  diarias_alt: 'https://us-central1-kmfengenharia.cloudfunctions.net/diarias',

  // Funções auxiliares para controle de diárias
  getPedreirosUrl: () => 'https://pedreiros-jtoioxpfwq-uc.a.run.app',
  getPedreiroUrl: (pedreiroId) => `https://pedreiros-jtoioxpfwq-uc.a.run.app/${pedreiroId}`,
  updatePedreiroUrl: (pedreiroId) => `https://pedreiros-jtoioxpfwq-uc.a.run.app/${pedreiroId}`,
  deletePedreiroUrl: (pedreiroId) => `https://pedreiros-jtoioxpfwq-uc.a.run.app/${pedreiroId}`,
  
  getDiariasUrl: () => 'https://diarias-jtoioxpfwq-uc.a.run.app',
  getDiariaUrl: (diariaId) => `https://diarias-jtoioxpfwq-uc.a.run.app/${diariaId}`,
  updateDiariaUrl: (diariaId) => `https://diarias-jtoioxpfwq-uc.a.run.app/${diariaId}`,
  deleteDiariaUrl: (diariaId) => `https://diarias-jtoioxpfwq-uc.a.run.app/${diariaId}`,

  // Funções auxiliares para verificação de email
  getSolicitarVerificacaoEmailUrl: () => 'https://solicitarverificacaoemail-jtoioxpfwq-uc.a.run.app',
  getVerificarEmailUrl: () => 'https://verificaremail-jtoioxpfwq-uc.a.run.app',
  getSolicitarVerificacaoEmailAltUrl: () => 'https://us-central1-kmfengenharia.cloudfunctions.net/solicitarVerificacaoEmail',
  getVerificarEmailAltUrl: () => 'https://us-central1-kmfengenharia.cloudfunctions.net/verificarEmail',
};

export default API_URLS; 